import React from 'react'

function KiloActif({nbKilo, nbKiloFalse}) {
  return (
    <div className="col-md-6 col-xl-3 mb-4">
        <div className="card shadow border-start-success py-2">
            <div className="card-body">
                <div className="row align-items-center no-gutters">
                    <div className="col me-2">
                        <div className="text-uppercase text-success fw-bold text-xs mb-1">
                            <span>kilos actifs</span>
                        </div>
                        <div className="text-dark fw-bold h5 mb-0">
                            <span>{nbKilo-nbKiloFalse}</span>
                        </div>
                    </div>
                    <div className="col-auto">
                        <i className="fas fa-plane-departure fa-2x text-gray-300" style={{fontSize: '38px'}}></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default KiloActif